import { controls } from "../../controls";

const rp552 = {
  label: "CASA AADHAR",
  pageLabel: "CASA AADHAR REPORT",
  starting: true,
  url: "rp552",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-2" }),
    ...controls.Taluka({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "Product Code", width: "col-sm-2" }),
    ...controls.product({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "product_code_display", name: "product_code_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "As on Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "as_on_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),


    ...controls.displayText({ tab: "filter", label: "Last Transaction Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "last_trn_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-3 " }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter' }),
  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "CASA AADHAR REPORT",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Operative Savings A/c excluding small A/c",
        accessor: "savingregular",
        rwidth: "*"
      },
      {
        Header: "Operative Savings A/c excluding small A/c with AADHAR",
        accessor: "savingregularwithadhar",
        rwidth: "*"
      },
      {
        Header: "Operative Savings A/c excluding small A/c with AADHAR Authenticate",
        accessor: "savingregularwithadhar",
        rwidth: "*"
      },
      {
        Header: "Operative Current A/c",
        accessor: "currentacs",
        rwidth: "*"
      },
      {
        Header: "Operative Current A/c with AADHAR",
        accessor: "currentacswithadhar",
        rwidth: "*"
      },
      {
        Header: "Operative Current A/c with AADHAR Authenticate",
        accessor: "currentacswithadhar",
        rwidth: "*"
      },
      {
        Header: "Operative Small Accounts",
        accessor: "savingsmall",
        rwidth: "*"
      },
      {
        Header: "Operative Small A/c with AADHAR",
        accessor: "savingsmallwithadhar",
        rwidth: "*"
      },
      {
        Header: "Operative Small A/c with AADHAR Authenticate",
        accessor: "savingsmallwithadhar",
        rwidth: "*"
      }
    ]
  }
};

export default rp552;